(() => {
  if (window.__enehillsLegacyShowcaseRepair) return;
  window.__enehillsLegacyShowcaseRepair = true;

  function imageUrl(image) {
    if (typeof image === 'string') return image;
    return image?.src || '';
  }

  function formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'HKD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'zh-HK', {
        style: 'currency',
        currency,
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return `${currency} ${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  }

  async function repairLegacyShowcaseProduct() {
    const rows = [...document.querySelectorAll('[data-eh-row]')].filter((row) => {
      const currentLink = row.dataset.link || row.getAttribute('href') || '';
      try {
        return new URL(currentLink, window.location.origin).pathname.endsWith('/products/accessory');
      } catch (error) {
        return false;
      }
    });
    if (!rows.length) return;

    const locale = window.location.pathname.match(/^\/(zh|en)(?=\/|$)/)?.[1];
    const link = `${locale ? `/${locale}` : ''}/products/metal-plate`;
    const lang = (document.documentElement.lang || '').toLowerCase();
    const subtitle = lang.startsWith('zh')
      ? '為指定安裝位置提供磁吸配件固定基礎'
      : lang.startsWith('ja')
        ? '指定した設置位置に磁気アクセサリー用の固定面を追加'
        : 'Magnetic mounting base for selected installation positions';

    rows.forEach((row) => {
      row.href = link;
      row.dataset.link = link;
      row.dataset.usageLink = `${link}#usage-scenarios`;
      row.dataset.title = 'Metal Plate';
      row.dataset.subtitle = subtitle;
      row.dataset.summary = 'MagSafe';
      row.querySelector('.eh-row-main strong')?.replaceChildren('Metal Plate');
    });

    try {
      const response = await fetch(`${link}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const product = await response.json();
      const fallbackImage = imageUrl(product.featured_image);
      const variants = (product.variants || []).map((variant) => ({
        id: variant.id,
        title: variant.title,
        available: variant.available,
        price: formatMoney(variant.price),
        image: imageUrl(variant.featured_image) || fallbackImage,
        option1: variant.option1,
        option2: variant.option2,
        option3: variant.option3,
      }));
      const firstVariant = variants.find((variant) => variant.available) || variants[0];
      const displayPrice = firstVariant?.price || formatMoney(product.price);

      rows.forEach((row) => {
        const rowIndex = row.dataset.index;
        const root = row.closest('[id^="EnehillsShowcase-"]');
        const makeAvailable = () => {
          row.dataset.hasProduct = variants.length ? 'true' : 'false';
          row.dataset.variants = JSON.stringify(variants);
          row.classList.remove('is-unavailable');
          row.removeAttribute('aria-hidden');
          row.removeAttribute('tabindex');
          const dot = root?.querySelector(`[data-eh-dot][data-index="${rowIndex}"]`);
          dot?.classList.remove('is-unavailable');
          dot?.setAttribute('aria-label', 'Metal Plate');
        };

        row.dataset.price = displayPrice;
        row.dataset.image = fallbackImage;
        row.dataset.hydrated = 'true';
        row.querySelector('.eh-row-main small')?.replaceChildren(displayPrice);
        const image = row.querySelector('.eh-thumb img');
        if (image && fallbackImage) {
          image.src = fallbackImage;
          image.alt = 'Metal Plate';
        }

        makeAvailable();
        window.setTimeout(makeAvailable, 250);
        window.setTimeout(makeAvailable, 1000);
        window.setTimeout(makeAvailable, 2500);
        if (row.classList.contains('is-active')) row.click();
      });
    } catch (error) {
      // The corrected link remains usable if product hydration is temporarily unavailable.
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repairLegacyShowcaseProduct, { once: true });
  } else {
    repairLegacyShowcaseProduct();
  }
})();
